import { Component, OnInit, ViewChild } from '@angular/core';
import { EditorComponent } from '../../../base/editor/editor.component';
import { HistoryComponent } from '../../../fragments/history/history.component';
import { AppService } from '../../../../services/app.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ProductService } from '../../../../services/products/product.service';
import { ProductEnvelope } from '../../../../models/net/envelope/product-envelope';

@Component({
    selector: 'app-html-content',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.css', '../../../../app.component.css']
})

export class ProductComponent extends EditorComponent {

    @ViewChild("appHistory") appHistory!: HistoryComponent;

    public constructor(public override appService: AppService, public override itemService: ProductService, public override route: ActivatedRoute, public override location: Location) {

        super(appService, itemService, route, location, "content", "contents");
    }

    public override initializeEnvelope = (envelope: ProductEnvelope | null): void => {

        super.initializeEnvelope(envelope);

        this.itemEnvelope = new ProductEnvelope(envelope);
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);

        if (this.itemEnvelope?.Document.Item.Body === null || this.itemEnvelope?.Document.Item.Body === undefined) {

            this.itemEnvelope!.Document.Item.Body = "";
        }
    }

    public ngAfterViewInit(): void {

        //this.toChipSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

        //    this.toContactIds.push(item.Id);
        //    this.addMessageContactToMessage(item.Id, 1);
        //});
    }
}
